const btnExpiredServices = {
  label: 'filtros',
  Typography: 'Ningún resultado encontrado'
};

export default btnExpiredServices;
